import React from 'react'
import { useEffect } from 'react'
import { Header } from '@kbbsdk/global-sdk/navigation/web'
import { BrowserUtils } from '../../utils/siteUtils'
import styled from '@emotion/styled'
import useEventBus from '../generic/useEventBus'

export default ({ links = [], isBuildStep, brand = 'kbb', environment }) => {
  useEffect(() => {
    BrowserUtils.addScript(`${environment.userWebComponentsUrl}?v=${new Date().getDate()}`, document.head, 'module', false)
    // Use cai-authentication-modal to test at lower environments
    if (environment.caiAuthModalEnabled) {
      BrowserUtils.addScript(`${environment.caiAuthWebComponentsUrl}?v=${new Date().getDate()}`, document.head, 'module', false)
      const modal = document.querySelector('cai-authentication-modal')
      const button = document.querySelector('#openmodal')

      button.addEventListener('click', () => {
        modal.open()
      })
    }
  }, [])

  if (process.env.BUILD_STAGE !== 'build-html') {
    useEventBus('auth.signin', data => {
      const userProfile = document.querySelector('user-profile-hydrator')
      userProfile.setAttribute('is-logged-in', true)
    })

    useEventBus('auth.signout', data => {
      const userProfile = document.querySelector('user-profile-hydrator')
      userProfile.setAttribute('is-logged-in', false)
    })
  }

  return (
    <>
      {!isBuildStep && (
        <StyledHeaderDiv>
          <Header id={'globalHeader'} navigation={links} isRefreshedLogo={true} withMyKbb={true} useWebComponent={true} suppressZipCode={true} ignoreWebComponentJS={true} />
          {/* Use cai-authentication-modal to test at lower environments */}
          {environment.caiAuthModalEnabled && (
            <>
              <cai-authentication-modal brand={brand} screen="signin" auto-open="false"></cai-authentication-modal>
              <div class="mock-body-content">
                <button id="openmodal">Sign In</button>
              </div>
            </>
          )}
        </StyledHeaderDiv>
      )}
    </>
  )
}

const StyledHeaderDiv = styled.div`
  display: flex;
  background-color: #1f3e74;
`
